export const GIT_COMMIT = '8a7b15791906ce4218a3a4ebf43969039b529727';
